/**
 * Secondary Product Variant Selection - Laoli Theme
 * Completely independent variant selector with identical functionality
 * Uses different class names and separate logic from the main selector
 */

function initPdpSelectSecondary() {
  const pdpWrapper = document.querySelector('.laoli-pdp');

  if (!pdpWrapper) {
    return;
  }
  
  const priceWrapper = document.querySelector('.laoli-pdp-desktop-info-price');
  const mobilePriceWrapper = document.querySelector('.laoli-pdp-mobile-info-price');
  
  // Find secondary selects
  const secondarySelects = document.querySelectorAll('.laoli-pdp-desktop-secondary-sizes');
  const status = document.querySelectorAll('.js-status');
  const addButton = document.querySelectorAll('.js-add-secondary');



  const inStockText = pdpWrapper.getAttribute('data-inStockText');
  const madeToOrderText = pdpWrapper.getAttribute('data-madeToOrderText');
  const addToCartText = pdpWrapper.getAttribute('data-addToCartText');
  const preOrderText = pdpWrapper.getAttribute('data-preOrderText');

  // Check if product has multiple variants
  const hasMultipleVariants = secondarySelects.length > 0 && !secondarySelects[0].closest('.laoli-pdp-desktop-secondary-sizes-wrapper').classList.contains('hidden');
  const hasSingleOrNoVariants = secondarySelects.length === 0 || secondarySelects[0].closest('.laoli-pdp-desktop-secondary-sizes-wrapper').classList.contains('hidden');



  // Initialize status visibility based on variant count
  if (hasMultipleVariants) {
    // Hide status initially when there are multiple variants
    status.forEach(s => {
      s.style.display = 'none';
    });
  } else {
    // Show status always when there are no variants or only one variant
    status.forEach(s => {
      s.style.display = 'block';
    });
  }

  // Initialize button state
  addButton.forEach(btn => {
    if (hasMultipleVariants) {
      // For products with multiple variants, check if a variant is selected
      const hasPlaceholder = document.querySelector('.laoli-pdp-desktop-secondary-sizes-value[data-placeholder="true"]');
      if (hasPlaceholder) {
        btn.disabled = true;
        btn.classList.add('disabled');
        console.log('🔒 Secondary button disabled: waiting for variant selection');
      } else {
        btn.disabled = false;
        btn.classList.remove('disabled');
        // Secondary button enabled: variant already selected
      }
    } else {
      // For products with no variants or single variant, enable button immediately
      btn.disabled = false;
      btn.classList.remove('disabled');
    }
  });

  // Initialize status styling based on initial text
  status.forEach(s => {
    const statusText = s.textContent.trim();
    if (statusText === madeToOrderText.trim()) {
      s.setAttribute('data-status', 'made-to-order');
    }
  });

  // Close all secondary menus initially
  const allSecondaryMenus = document.querySelectorAll('.laoli-pdp-desktop-secondary-sizes-menu');
  allSecondaryMenus.forEach(menu => {
    menu.style.display = 'none';
  });



  // Add click outside handler to close secondary menus
  document.addEventListener('click', function(event) {
    const isClickInsideSecondarySelect = event.target.closest('.laoli-pdp-desktop-secondary-sizes-wrapper');
    if (!isClickInsideSecondarySelect) {
      allSecondaryMenus.forEach(menu => {
        menu.style.display = 'none';
      });
    }
  });



  // Define the menu click handler function outside the loop to avoid recreation
  const handleSecondaryMenuClick = function(event) {
    const target = event.target;

    if (target.classList.contains('laoli-pdp-desktop-secondary-sizes-menu-item')) {
      
      // Show status when a variant is selected
      status.forEach(s => {
        s.style.display = 'block';
      });
      
      if (target.classList.contains('laoli-pdp-desktop-secondary-sizes-menu-item_empty')) {
        status.forEach(s => {
          s.textContent = madeToOrderText;
          s.setAttribute('data-status', 'made-to-order');
        });
        addButton.forEach(btn => btn.value = addToCartText);
      } else {
        status.forEach(s => {
          s.textContent = inStockText;
          s.removeAttribute('data-status');
        });
        addButton.forEach(btn => btn.value = addToCartText);
      }

      // Enable add to cart button when a variant is selected
      addButton.forEach(btn => {
        btn.disabled = false;
        btn.classList.remove('disabled');
      });

      // Find the selected value element in the same wrapper
      const selectWrapper = target.closest('.laoli-pdp-desktop-secondary-sizes-wrapper');
      const selectedValue = selectWrapper.querySelector('.laoli-pdp-desktop-secondary-sizes-value');
      
      if (selectedValue) {
        selectedValue.textContent = target.textContent.trim();
        selectedValue.removeAttribute('data-placeholder');
      }
      
      // Update the placeholder detection for button state
      const hasPlaceholder = document.querySelector('.laoli-pdp-desktop-secondary-sizes-value[data-placeholder="true"]');
      if (!hasPlaceholder) {
        status.forEach(s => {
          s.style.display = 'block';
        });
      }
      
      // Update the hidden form input with selected variant ID
      const formInput = document.querySelector('.js-cart-form input[name="id"]');
      if (formInput) {
        formInput.value = target.getAttribute('data-id');
        console.log('✅ Updated form input with secondary variant ID:', target.getAttribute('data-id'));
      }
      
      const price = target.getAttribute('data-price');
      if (priceWrapper) {
        priceWrapper.textContent = price;
      }
      if (mobilePriceWrapper) {
        mobilePriceWrapper.textContent = price;
      }
      
      // Close all secondary menus after selection
      console.log('🔽 Closing all secondary menus after selection');
      allSecondaryMenus.forEach(menu => {
        console.log('🔽 Closing menu:', menu);
        menu.style.display = 'none';
        menu.classList.remove('show-menu', 'visible');
      });
      
      // Remove event listener to prevent duplicates
      const currentMenu = target.closest('.laoli-pdp-desktop-secondary-sizes-menu');
      if (currentMenu) {
        console.log('🔧 Removing event listener from menu');
        currentMenu.removeEventListener('click', handleSecondaryMenuClick);
      }
      
      console.log('✅ Secondary menu item selection completed successfully');
    }
  };

  secondarySelects.forEach((select, index) => {
    // Force enable clicks
    select.style.pointerEvents = 'auto';
    select.style.cursor = 'pointer';
    
    console.log(`🔍 Setting up secondary select ${index}:`, select);
    
    // Add click event listener
    select.addEventListener('click', function(e) {
      console.log('🖱️ Secondary select clicked!', this);
      e.preventDefault();
      e.stopPropagation();
      
      const selectWrapper = this.closest('.laoli-pdp-desktop-secondary-sizes-wrapper');
      
      if (!selectWrapper) {
        return;
      }
      
      const menu = selectWrapper.querySelector('.laoli-pdp-desktop-secondary-sizes-menu');
      const selectedValue = selectWrapper.querySelector('.laoli-pdp-desktop-secondary-sizes-value');
      

      
      if (!menu) {
        return;
      }
      
      // Close all other secondary menus first
      allSecondaryMenus.forEach(otherMenu => {
        if (otherMenu !== menu) {
          otherMenu.style.display = 'none';
        }
      });
      
      // Toggle current menu
      const currentDisplay = menu.style.display;
      let newDisplay;
      
      if (currentDisplay === 'block') {
        newDisplay = 'none';
        menu.classList.remove('show-menu', 'visible');
        // Remove click handler when closing menu
        menu.removeEventListener('click', handleSecondaryMenuClick);
      } else {
        newDisplay = 'block';
        menu.classList.add('show-menu', 'visible');
      }
      
      menu.style.display = newDisplay;
      
      // Force secondary menu items to be visible when menu is opened
      if (newDisplay === 'block') {
        const menuItems = menu.querySelectorAll('.laoli-pdp-desktop-secondary-sizes-menu-item');
        
        menuItems.forEach((item, index) => {
          // Remove any inline display: none styles
          if (item.style.display === 'none') {
            item.style.removeProperty('display');
          }
          // Force display block
          item.style.display = 'block';
        });
      }
      
      // Always add click handler when menu is visible
      if (newDisplay === 'block') {
        // Remove any existing click handlers first to prevent duplicates
        menu.removeEventListener('click', handleSecondaryMenuClick);
        
        // Add the click handler to the menu
        menu.addEventListener('click', handleSecondaryMenuClick);
      }

    });
  });
}

// Export for use in other scripts
if (typeof module !== 'undefined' && module.exports) {
  module.exports = { initPdpSelectSecondary };
}
